import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
type Props = {
  className?: string;
  id: number;
  isActive: boolean;
  name: string;
  onClick: (id: number) => void;
  price: string | null | undefined;
  shortName: string;
  year: number;
};
export const BookingCalendarMonth = ({
  className,
  id,
  isActive,
  name,
  onClick,
  price,
  shortName,
  year,
}: Props) => (
  <button
    className={classnames(
      'flex w-full cursor-pointer flex-col items-center justify-center overflow-hidden rounded-12 sm:p-10',
      {
        'bg-white text-black': !isActive,
        'bg-ultramarine font-bold text-white': isActive,
      },
      className,
    )}
    onClick={() => onClick(id)}
    type="button"
  >
    <div className="w-full truncate text-center text-12 uppercase sm:text-14">
      {isActive ? name : shortName}
      {isActive && <span> {year}</span>}
    </div>
    {!!price && (
      <Fragment>
        <div className="w-full truncate text-10 uppercase sm:text-12">{t('price.format.from')}</div>
        <div className="text-10 sm:mt-10 sm:text-14">{price}</div>
      </Fragment>
    )}
  </button>
);
